<template>
    <div class="box-typical-upload box-typical-upload-in">
        <div v-if="config.description" class="alert alert-info" role="alert">
            <span v-html="config.description"></span>
        </div>
        <div v-if="files.length > 0 || rejectedFiles.length > 0" style="margin: 1em 0;">
            <h6 class="uploading-list-title">Uploading</h6>
            <ul class="uploading-list list-unstyled">
                <li v-for="file in files" :key="file.name" class="uploading-list-item">
                    <div class="uploading-list-item-wrapper">
                        <div class="uploading-list-item-name">
                            <i class="font-icon font-icon-cam-photo"></i>
                            {{file.name}}
                        </div>
                        <div class="uploading-list-item-size">{{getFileSize(file.size)}}</div>
                        <button v-on:click="removeFile(file.id)" type="button" class="uploading-list-item-close">
                            <i class="font-icon-close-2"></i>
                        </button>
                    </div>
                    <div class="progress">
                        <span class="progress-bar" :style="'width: ' + uploading[file.name] + '%;'"></span>
                    </div>
                    <div class="uploading-list-item-progress">{{uploading[file.name]}}%</div>
                    <div v-if="uploading[file.name] == 100" class="uploading-list-item-speed">Done</div>
                </li>
                <li v-for="file in rejectedFiles" :key="file.name" class="uploading-list-item" style="color: red;">
                    <div class="uploading-list-item-wrapper">
                        <div class="uploading-list-item-name">
                            <i class="font-icon font-icon-cam-photo"></i>
                            {{file.name}}
                        </div>
                        <div
                            class="uploading-list-item-size">Invalid extension</div>
                        <button v-on:click="removeFile(file.id)" type="button" class="uploading-list-item-close">
                            <i class="font-icon-close-2"></i>
                        </button>
                    </div>
                </li>
            </ul>
        </div>
        <drop v-on:dragleave="onDragLeave"
            v-on:dragover="onDragOver"
            v-on:drop="onFileDropped">
            <div class="drop-zone-wrapper">
                <div :class="['drop-zone', 'thumbnail', dragging ? 'dragover' : '']">
                    <template v-if="value">
                        <img v-if="value" :src="src + '?' + localTimestamp" class="upload-thumbnail" style="max-width: 200px;max-height: 200px;"/>

                        <button v-on:click="openModal" type="button" class="btn btn-rounded btn-md btn-primary" :disabled="disabled">
                            Replace file
                        </button>
                        <button v-on:click="setNullValue" type="button" class="btn btn-rounded btn-md btn-danger" :disabled="disabled">
                            Delete file
                        </button>
                    </template>
                    <template v-else>
                        <img src="/img/icons/cloud-bl.svg" alt="Cloud">
                        <div class="drop-zone-caption">
                            <h2>You haven't assigned an file to this content yet.</h2>
                            <p>Drag a file here to upload directly or select an existing file from your site assets</p>
                        </div>
                        <button v-on:click="openModal" type="button" class="btn btn-rounded btn-md btn-success" :disabled="disabled">
                            Select file
                        </button>
                        <span class="btn btn-rounded btn-md btn-file">
                            <span>Upload file</span>
                            <input type="file" :disabled="disabled"
                                v-on:change="onFileSelected"
                                style="left: -330px; top: -130px;"/>
                        </span>
                    </template>
                </div>
            </div>
        </drop>

        <file-modal-component
            v-on:change="updateValue"
            v-on:close="closeFileModal"
            :show="selecting"
            :storagePanel="_.get(config, 'storagePanel')"
            :currentAsset="asset"
            :closeModal="closeFileModal"
            :extensions="extensions"
            ></file-modal-component>
    </div>
</template>
<script>
import Vue from 'vue';
import Vuex from 'vuex';
import filesize from 'filesize';
import mime from 'mime-types';

import { Drop } from 'vue-drag-drop';
import FileModalComponent from '../helpers/FileModalComponent';

export default {
    data() {
        return {
            selecting: false,
            dragging: false,
            loading: true,
            assets: null,
            asset: null,
            localTimestamp: Date.now(),

            files: [],
            rejectedFiles: [],
            uploading: {},
        }
    },

    props: ['value', 'label', 'description', 'required', 'disabled', 'state', 'error', 'config'],

    components: {
        FileModalComponent,
        Drop,
    },

    watch: {

    },

    computed: {
        src() {
            return _.isObject(this.value) ? _.imgPath(this.value) : `/asset/${this.value}/Cover.jpg`;
        },
        extensions(){
            return _.get(this.config, 'extensions');
        }
    },

    methods: {
        ...Vuex.mapActions('assets', {
            createAsset: 'createData',
        }),

        uploadFile(data) {
            return this.createAsset({
                data: {
                    ...data,
                    parent_id: this.currentParent || '',
                    storage: this.currentStorage || '',
                },
                options: {
                    upload: true,
                    addToCollection: true,
                }
            });
        },

        // connect with component v-model
        updateValue(value) {
            this.localTimestamp = Date.now();
            this.$emit('input', value);
            this.selecting = false;
        },

        removeValue() {
            this.$emit('input', null);
        },

        openFileModal() {
            this.selecting = true;
        },

        closeFileModal() {
            this.selecting = false;
        },

        onFileDropped(_, e) {
            e.preventDefault();
            if (this.disabled) return;

            this.dragging = false;
            const file = e.dataTransfer.files[0];
            this.uploadFiles([file]);
        },

        onFileSelected(e) {
            e.preventDefault();
            const file = e.target.files[0];
            this.uploadFiles([file]);
        },

        getFileArray(fileList) {
            const length = fileList.length;
            const fileArray = [];
            const timestamp = Date.now();
            for (let i = 0; i < length; i++) {
                const file = fileList.item(i);
                file.id = `${timestamp}.${i}`;
                fileArray.push(fileList.item(i));
            }
            return fileArray;
        },

        getFileSize(val) {
            return filesize(val);
        },

        selectValue(value) {

        },

        uploadFiles(files) {
            this.files = files.filter(file => this.extensions.indexOf(mime.extension(file.type)) >= 0);
            this.rejectedFiles = files.filter(file => this.extensions.indexOf(mime.extension(file.type)) < 0);

            Promise.all(this.files.map(file => {
                this.uploading[file.name] = 0;
                return this.uploadFile({ file })
                    .then((response) => {
                        this.$emit('input', response);
                        this.uploading = { ...this.uploading, [file.name]: 100 };
                        setTimeout(() => {
                            this.files = [];
                        }, 1000)
                    })
            }))
        },

        onDragOver(_, e) {
            e.preventDefault();
            if (!this.disabled) {
                this.dragging = true;
            }
        },

        onDragLeave(_, e) {
            e.preventDefault();
            this.dragging = false;
        },

        openModal() {
            this.selecting = true;
        },

        setNullValue() {
            this.$emit('input', null);
        }
    }
}
</script>



// WEBPACK FOOTER //
// seventytwo/72cms-ui/src/components/form-elements/FilePickerComponent.vue